import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { MyStore } from 'kts-platform-frame/redux';
import { serverDomain } from 'kts-platform-frame/entry/configUtils';
import superagent from 'superagent';
import { Urls } from 'kts-platform-frame/entry/constant';
import { history } from 'kts-platform-frame/routes';
import { message } from 'antd';

class ModulesAction extends ActionBasic<ModulesState> {
    // 初始化数据
    public initData = async (companyId: string) => {
        const { user } = MyStore.instance.getState();
        const res = await superagent
            .post(serverDomain()+ Urls.outsidInfo)
            .send({
                companyId: companyId,
                authToken: user.aToken || user.cToken
            })
            .on('error', e => {
                message.error('获取数据失败');
            });
        if (!res.body || res.body.status.returnCode !== "200" ) {
            message.error(res.body.status.description);
            setTimeout(() => {
                history.push('/login');
            }, 1500);
            return;
        }
        this.modulesState.companyInfo = res.body.body;
        if (this.modulesState.companyInfo.mainImageUrl) {
            let imageUrls = this.modulesState.companyInfo.imageUrls || [];
            imageUrls.unshift(this.modulesState.companyInfo.mainImageUrl);
        }
        this.modulesState.companyId = companyId;
        this.setModulesState();
    }
    // 发票列表
    public detailPubConfig = async (companyId: string) => {
        const { user } = MyStore.instance.getState();
        const res = await superagent
            .post(serverDomain()+ Urls.detailPubConfig)
            .send({
                companyId: companyId,
                authToken: user.aToken || user.cToken
            })
            .on('error', e => {
                message.error('获取数据失败');
            });
        if (!res.body || res.body.status.returnCode !== "200") {
            message.error(res.body.status.description);
            // setTimeout(() => {
            //     history.push('/login');
            // }, 1500);
            return;
        }
        if (res.body.body) {
            this.modulesState.invoiceList = res.body.body.emailCopanyConfigPubInfos;
        }
        this.setModulesState();
    }
    // 展示公司风采 弹框
    public showEleganceModal = (isShow: boolean, src?: string) => {
        this.modulesState.showEleganceModal = isShow;
        this.modulesState.imgUrlElegance = src;
        this.setModulesState();
    }
    /**
     * 打开/关闭 抽屉
     */
    public onCloseDrawer = (isShow: boolean) => {
        this.modulesState.visibleDrawer = isShow;
        this.modulesState.drawerSelect = 'upload';
        this.setModulesState();
    }
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/modules/Home/CompanyPublic/Modules.Action.ts